import { render } from "./BlackButton.vue?vue&type=template&id=cc78e33e&scoped=true"
import script from "./BlackButton.vue?vue&type=script&lang=js"
export * from "./BlackButton.vue?vue&type=script&lang=js"

import "./BlackButton.vue?vue&type=style&index=0&id=cc78e33e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc78e33e"]])

export default __exports__